import {FC, useMemo} from 'react';
import {filter, map} from 'lodash';
import {observer} from 'mobx-react';
import {ButtonGroup} from 'semantic-ui-react';

import {useRackEditorStore} from '../hooks/useRackEditorStore';
import {useTooltip} from '../../components/graphs/GraphTooltips';
import RackEditorStore from '../store/RackEditorStore';
import {BaseActionButton} from './buttons/BaseActionButton';

type ActionButtonsPropsType = {
  buttons: Array<Array<any>>;
  containerRef: any;
};

const ActionButtons: FC<ActionButtonsPropsType> = ({buttons, containerRef}) => {
  const rackEditorStore: RackEditorStore = useRackEditorStore();
  const {sharedTooltip} = useTooltip();

  const groups: BaseActionButton[][] = useMemo(() => {
    return map(buttons, (group) =>
      map(group, (ActionButton) => new ActionButton(rackEditorStore, sharedTooltip, containerRef)
      )
    );
  }, [rackEditorStore, sharedTooltip, buttons, containerRef]);

  return map(groups, (group, index) => {
    return (
      <ButtonGroup key={index}>
        {
          map(
            filter(group, ({visible}) => visible()),
            (button, buttonIndex) => button.renderWithAlerts(buttonIndex)
          )
        }
      </ButtonGroup>
    );
  });
};

export default observer(ActionButtons);
